"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _slate = require("slate");
var _slateReact = require("slate-react");
var _schema = require("./schema");
var _helpers = require("../../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const isValidJson = string => {
  try {
    JSON.parse(string);
  } catch (e) {
    return false;
  }
  return true;
};
class Viewer extends _react.default.Component {
  render() {
    const {
      value,
      fetching,
      fetched
    } = this.props;
    if (!value || fetching === true || fetched === false) {
      const words = Array.from({
        length: (0, _helpers.getRandomInt)(12, 36)
      });
      return /*#__PURE__*/_react.default.createElement("div", null, words.map((word, index) => /*#__PURE__*/_react.default.createElement("span", {
        key: index,
        className: 'component-string-placeholder mr-2' + (fetching ? ' fetching' : ''),
        style: {
          width: `${(0, _helpers.getRandomInt)(6, 12)}em`
        }
      })));
    }
    if (!isValidJson(value)) return /*#__PURE__*/_react.default.createElement("div", null, "No valid json");
    const parsed = _slate.Value.fromJSON(JSON.parse(value));
    return /*#__PURE__*/_react.default.createElement(_slateReact.Editor, {
      value: parsed,
      readOnly: true,
      renderNode: _schema.renderNode,
      renderMark: _schema.renderMark
    });
  }
}
var _default = exports.default = Viewer;
module.exports = exports.default;